/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * @emails react-core
 */

import MarkdownHeader from './MarkdownHeader';

export default MarkdownHeader;
